var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgFixedMeteora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #20800f;\n      }\n\n      .cls-2 {\n        fill: #1c151a;\n      }\n\n      .cls-3 {\n        fill: #20820f;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: #20181e;\n      }\n\n      .cls-7 {\n        fill: #7a1980;\n      }\n\n      .cls-8 {\n        fill: #ae23b6;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-10 {\n        fill: #259511;\n      }\n\n      .cls-11 {\n        fill: #463267;\n      }\n\n      .cls-12 {\n        isolation: isolate;\n      }\n\n      .cls-13 {\n        fill: #7d1982;\n      }\n\n      .cls-14 {\n        fill: #c427cd;\n      }\n\n      .cls-15 {\n        fill: #3d2c59;\n      }\n\n      .cls-16 {\n        fill: #140f13;\n      }\n\n      .cls-17 {\n        opacity: .7;\n      }\n\n      .cls-17, .cls-18, .cls-19 {\n        fill: #fff;\n        mix-blend-mode: screen;\n      }\n\n      .cls-18 {\n        opacity: .8;\n      }\n\n      .cls-19 {\n        opacity: .9;\n      }\n\n      .cls-20 {\n        fill: #ab22b3;\n      }\n\n      .cls-21 {\n        fill: #3c2b58;\n      }\n\n      .cls-22 {\n        fill: #171216;\n      }\n\n      .cls-23 {\n        fill: #1d151a;\n      }\n\n      .cls-24 {\n        fill: #8f1d95;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1799.83,
    y1: 1800,
    x2: 1799.83,
    y2: -0.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#821137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380c35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2478.31,
    y1: 141.63,
    x2: 2478.31,
    y2: 1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a53214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#531c0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 61.51,
    y1: -186.05,
    x2: 61.51,
    y2: 551.09,
    gradientTransform: "translate(244.03 121.01) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d83b1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#7a2817"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fixed_BG_-_Sky"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -0.17,
    y: -0.03,
    width: 3600,
    height: 1800.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 2478.31,
    cy: 944.31,
    r: 802.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 427.17,
    y: 234.17,
    width: 5.66,
    height: 5.66,
    transform: "translate(-41.64 373.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1795.35,
    y: 73.74,
    width: 8,
    height: 8,
    transform: "translate(472.05 1295.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 3209.94,
    y: 293.74,
    width: 8,
    height: 8,
    transform: "translate(730.81 2359.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1419.31,
    y: 490.23,
    width: 5.66,
    height: 5.66,
    transform: "translate(67.89 1150.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3429.31,
    y: 600.23,
    width: 5.66,
    height: 5.66,
    transform: "translate(578.83 2603.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 669.31,
    y: 620.23,
    width: 5.66,
    height: 5.66,
    transform: "translate(-243.7 657.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 763.78,
    y: 321.78,
    width: 8,
    height: 8,
    transform: "translate(-5.48 638.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 61.51,
    cy: 182.52,
    r: 368.57
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fixed_BG_-_Back_Buildings"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "3160.38 1516 3160.38 1804.67 2773.71 1804.67 2773.71 1520.17 3160.38 1516"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 2739.51,
    y: 1520.17,
    width: 34.2,
    height: 284.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "2773.71 1520.17 2739.51 1520.17 3126.18 1516 3160.38 1516 2773.71 1520.17"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "2221.39 1382.34 2221.39 1802.67 1834.71 1802.67 1834.71 1454.9 2221.39 1382.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1800.51,
    y: 1454.9,
    width: 34.2,
    height: 347.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1834.71 1454.9 1800.51 1454.9 2187.19 1382.34 2221.39 1382.34 1834.71 1454.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3494.24,
    y: 1265.94,
    width: 51.3,
    height: 45.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "3474.27 1229.18 3422.97 1229.18 3524.63 1229.18 3575.93 1229.18 3474.27 1229.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3121.2,
    y: 1141.84,
    width: 51.3,
    height: 87.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "3172.5 1141.84 3121.2 1141.84 3422.97 1141.84 3474.27 1141.84 3172.5 1141.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "3129.9 1265.94 3078.6 1265.94 3494.24 1265.94 3545.54 1265.94 3129.9 1265.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "3129.9 1311.79 3078.6 1311.79 3494.24 1311.79 3545.54 1311.79 3129.9 1311.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3129.9,
    y: 1265.94,
    width: 415.64,
    height: 45.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 3078.6,
    y: 1265.94,
    width: 51.3,
    height: 45.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3474.27,1229.18h101.66s0,582.54,0,582.54h-480.03s0-582.54,0-582.54h76.61v-87.34h301.77s0,87.34,0,87.34ZM3545.54,1311.79v-45.86h-415.64v45.86h415.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "3095.9 1229.18 3044.59 1229.18 3121.2 1229.18 3172.5 1229.18 3095.9 1229.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3044.59,
    y: 1229.18,
    width: 51.3,
    height: 582.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 2561.61,
    y: 1315.28,
    width: 34.2,
    height: 232.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "2475.83 1547.95 2441.62 1547.95 2561.61 1547.95 2595.81 1547.95 2475.83 1547.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2475.83,
    y: 1315.28,
    width: 119.99,
    height: 232.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2475.83 1315.28 2441.63 1315.28 2561.62 1315.28 2595.82 1315.28 2475.83 1315.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2441.63,
    y: 1315.28,
    width: 34.2,
    height: 232.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M2532.19,983.85l357.61,163.28v661.22h-707.96s0-661.22,0-661.22l350.35-163.28ZM2595.81,1547.95v-232.67h-119.99v232.67h119.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "2181.84 1147.14 2147.64 1147.14 2497.99 983.85 2532.19 983.85 2181.84 1147.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 2147.64,
    y: 1147.14,
    width: 34.2,
    height: 661.22
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "760.71 1431.33 1147.39 1453.9 1147.39 1801.67 760.71 1801.67 760.71 1431.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 726.51,
    y: 1431.33,
    width: 34.2,
    height: 370.34
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1450.39 1617 1450.39 1806.84 1063.72 1806.84 1063.72 1619.74 1450.39 1617"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1029.51,
    y: 1619.74,
    width: 34.2,
    height: 187.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1063.72 1619.74 1029.51 1619.74 1416.19 1617 1450.39 1617 1063.72 1619.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1532.76 1330.64 1498.56 1330.64 1913.99 1330.64 1948.19 1330.64 1532.76 1330.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1532.76 1309.33 1498.56 1309.33 1913.99 1309.33 1948.19 1309.33 1532.76 1309.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1498.56,
    y: 1309.33,
    width: 34.2,
    height: 21.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1498.56,
    y: 1309.33,
    width: 34.2,
    height: 56.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1532.76,
    y: 1309.33,
    width: 415.43,
    height: 21.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1297.67,
    y: 1366.26,
    width: 34.2,
    height: 437.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1331.87 1366.26 1297.67 1366.26 1498.56 1366.26 1532.76 1366.26 1331.87 1366.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1532.76 1309.33 1532.76 1330.64 1948.19 1330.64 1948.19 1366.26 1948.19 1407.89 1948.19 1803.91 1331.87 1803.91 1331.87 1366.26 1532.76 1366.26 1532.76 1309.33"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "372.25 462.17 338.04 462.17 371.5 462.17 405.7 462.17 372.25 462.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 207.59,
    y: 618.49,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 207.59,
    y: 551.1,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 207.59,
    y: 483.72,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 207.59,
    y: 416.34,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "198.54 664.51 164.34 664.51 207.59 664.51 241.79 664.51 198.54 664.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 198.54,
    y: 618.49,
    width: 43.25,
    height: 46.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 164.34,
    y: 618.49,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "198.54 618.49 164.34 618.49 207.59 618.49 241.8 618.49 198.54 618.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "198.54 597.13 164.34 597.13 207.59 597.13 241.79 597.13 198.54 597.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 198.54,
    y: 551.11,
    width: 43.25,
    height: 46.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "198.54 551.11 164.34 551.11 207.59 551.11 241.8 551.11 198.54 551.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 164.34,
    y: 551.11,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "198.54 529.75 164.34 529.75 207.59 529.75 241.79 529.75 198.54 529.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 198.54,
    y: 483.72,
    width: 43.25,
    height: 46.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 164.34,
    y: 483.72,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "198.54 483.72 164.34 483.72 207.59 483.72 241.8 483.72 198.54 483.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "198.54 462.36 164.34 462.36 207.59 462.36 241.79 462.36 198.54 462.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 198.54,
    y: 416.34,
    width: 43.25,
    height: 46.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 164.34,
    y: 416.34,
    width: 34.2,
    height: 46.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "198.54 416.34 164.34 416.34 207.59 416.34 241.8 416.34 198.54 416.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "104.58 374.82 70.37 374.82 338.04 374.82 372.25 374.82 104.58 374.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 70.37,
    y: 374.82,
    width: 34.2,
    height: 87.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M372.25,462.17h33.46s0,1344.56,0,1344.56H27.97s0-1344.56,0-1344.56h76.6v-87.35h267.67s0,87.35,0,87.35ZM241.79,597.13v-46.03h-43.25v46.03h43.25M241.79,664.51v-46.03h-43.25v46.03h43.25M241.79,529.75v-46.03h-43.25v46.03h43.25M241.79,462.36v-46.03h-43.25v46.03h43.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "27.97 462.17 -6.23 462.17 70.37 462.17 104.58 462.17 27.97 462.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -6.23,
    y: 462.17,
    width: 34.2,
    height: 1344.56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1237.83 626.18 1203.63 626.18 1223.66 626.18 1257.86 626.18 1237.83 626.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1237.83,
    y: 626.18,
    width: 20.03,
    height: 1178.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1203.63,
    y: 626.18,
    width: 34.2,
    height: 1178.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1171.22 626.18 1137.02 626.18 1203.63 626.18 1237.83 626.18 1171.22 626.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1137.02,
    y: 626.18,
    width: 34.2,
    height: 117.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1104.61 743.62 1070.41 743.62 1137.02 743.43 1171.22 743.43 1104.61 743.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1084.59 743.62 1050.39 743.62 1070.41 743.62 1104.61 743.62 1084.59 743.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1084.59 481.92 1050.39 481.92 1070.41 481.92 1104.61 481.92 1084.59 481.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1050.39,
    y: 481.92,
    width: 34.2,
    height: 261.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1104.61 481.92 1104.61 743.43 1084.59 743.62 1084.59 481.92 1104.61 481.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1027.26,
    y: 481.92,
    width: 34.2,
    height: 144.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1061.46 481.92 1027.26 481.92 1050.39 481.92 1084.59 481.92 1061.46 481.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1084.59 481.92 1084.59 743.62 1104.61 743.62 1171.22 743.43 1171.22 626.18 1237.83 626.18 1237.83 1804.36 1257.86 1804.36 963.6 1804.36 963.6 626.18 1061.46 626.18 1061.46 481.92 1084.59 481.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "963.6 626.18 929.39 626.18 1027.26 626.18 1061.46 626.18 963.6 626.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 929.39,
    y: 626.18,
    width: 34.2,
    height: 1178.18
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "864.56 1381.84 864.56 1802.18 477.89 1802.18 477.89 1454.42 864.56 1381.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 443.69,
    y: 1454.42,
    width: 34.2,
    height: 347.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "477.89 1454.42 443.69 1454.42 830.36 1381.84 864.56 1381.84 477.89 1454.42"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFixedMeteora);
export default __webpack_public_path__ + "static/media/bg-fixed-meteora.ae38df5064e8201de98257695897bad9.svg";
export { ForwardRef as ReactComponent };